import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jksxubn7g5: FaireBrandEntity = {
  token: "b_jksxubn7g5",
  type: "brand",
  name: "Marlowe & Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/d1406596d2a26e2bcedba41e922cede06b0138e6a8b3c67ab97f1dc0aa88a8fc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d91e93fefe251b99985b52b11b7c3568ade0e93b264763d96d0ca694b4149255.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d1406596d2a26e2bcedba41e922cede06b0138e6a8b3c67ab97f1dc0aa88a8fc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d91e93fefe251b99985b52b11b7c3568ade0e93b264763d96d0ca694b4149255.jpeg",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 108,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Marlowe & Co! We are a family owned company that delights in creating quality and beautiful children's products and toys for the modern family. My name is Anita, and I founded Marlowe & Co in 2019. I find inspiration for our product designs from my own children and a love for simplistic Scandinavian design. At Marlowe & Co we are passionate about creating modern and timeless products that that will last for years to come. \n\nWe only use the softest fabric for our clothing and accessories, and eco-friendly material for our toys. Our products are third party CPSC tested and approved for compliance and safety. From concept to creation and packaging we care about the small details, and we pour our heart into each product. Thank you for being apart of our journey.\n\nDetails: We select the most affordable shipping carrier unless otherwise requested. Most of our products have simple and sustainable packaging.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:06.210Z",
    importedBy: "entity-db-cli",
  },
};
